import TreeNode from "./TreeNode";

export default class ProjectTreeNode extends TreeNode {
    constructor(project, id) {
        super(project, id);
    }

    getIdPrefix() {
        return "p";
    }

    getType() {
        return TreeNode.TYPE_PROJECT
    }
}


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/ProjectTreeNode.js